import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FiSend, FiMail, FiMapPin, FiGithub, FiLinkedin, FiCheckCircle } from 'react-icons/fi';
import { publicAPI } from '../services/api';
import { toast } from 'react-toastify';
import SectionHeader from '../components/common/SectionHeader';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = 'Name is required';
    if (!form.email.trim()) errs.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = 'Invalid email';
    if (!form.message.trim()) errs.message = 'Message is required';
    else if (form.message.length < 10) errs.message = 'Message must be at least 10 characters';
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    setSubmitting(true);
    try {
      const res = await publicAPI.sendContact(form);
      if (res.success) {
        setSent(true);
        toast.success('Message sent successfully!');
        setForm({ name: '', email: '', subject: '', message: '' });
      }
    } catch (err) {
      toast.error('Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: '' });
  };

  return (
    <section className="section contact-page">
      <Helmet><title>Contact | Deepak Chauhan</title></Helmet>
      <div className="container">
        <SectionHeader title="Get In Touch" subtitle="Have a question or want to work together?" />

        <div className="contact-grid">
          <div className="contact-info">
            <div className="contact-info-card glass">
              <FiMail />
              <h3>Email</h3>
              <a href="mailto:dc9958211@gmail.com">dc9958211@gmail.com</a>
            </div>
            <div className="contact-info-card glass">
              <FiMapPin />
              <h3>Location</h3>
              <p>India</p>
            </div>
            <div className="contact-info-card glass">
              <FiGithub />
              <h3>GitHub</h3>
              <a href="https://github.com/Deep5181" target="_blank" rel="noreferrer">github.com/deepakchauhan</a>
            </div>
            <div className="contact-info-card glass">
              <FiLinkedin />
              <h3>LinkedIn</h3>
              <a href="https://www.linkedin.com/in/deepak-chauhan-03b0b622b/" target="_blank" rel="noreferrer">linkedin.com/in/deepakchauhan</a>
            </div>
          </div>

          <div className="contact-form-wrapper">
            {sent ? (
              <div className="contact-success">
                <FiCheckCircle size={60} />
                <h2>Thank You!</h2>
                <p>Your message has been sent successfully. I'll get back to you soon.</p>
                <button className="btn btn-primary" onClick={() => setSent(false)}>Send Another Message</button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Name *</label>
                    <input type="text" name="name" value={form.name} onChange={handleChange}
                      className={errors.name ? 'error' : ''} placeholder="Your name" />
                    {errors.name && <span className="form-error">{errors.name}</span>}
                  </div>
                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="email" value={form.email} onChange={handleChange}
                      className={errors.email ? 'error' : ''} placeholder="Your email" />
                    {errors.email && <span className="form-error">{errors.email}</span>}
                  </div>
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <input type="text" name="subject" value={form.subject} onChange={handleChange} placeholder="Subject" />
                </div>
                <div className="form-group">
                  <label>Message *</label>
                  <textarea name="message" rows="6" value={form.message} onChange={handleChange}
                    className={errors.message ? 'error' : ''} placeholder="Your message"></textarea>
                  {errors.message && <span className="form-error">{errors.message}</span>}
                </div>
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                  <FiSend /> {submitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
